import React from 'react';
import { PhoneIcon, CalendarIcon } from 'lucide-react';
export function MobileStickyBar() {
  return <div className="md:hidden fixed bottom-0 left-0 right-0 bg-background/95 backdrop-blur border-t border-gold/30 z-50 px-4 py-3 flex gap-3 shadow-[0_-8px_24px_rgba(31,27,23,0.08)]" data-id="element-487">
      <a href="tel:0893162321" className="flex-1 flex items-center justify-center gap-2 py-3 bg-surface border border-gold/30 text-primary font-medium text-sm tracking-wide hover:bg-paper transition-colors" data-id="element-488">
        <PhoneIcon className="w-4 h-4 text-gold-dark" data-id="element-489" />
        Call
      </a>
      <a href="#consultation" className="flex-[1.5] flex items-center justify-center gap-2 py-3 bg-primary text-white font-medium text-sm tracking-wide hover:bg-navy transition-colors" data-id="element-490">
        <CalendarIcon className="w-4 h-4 text-gold-light" data-id="element-491" />
        Book a Consultation
      </a>
    </div>;
}